module.exports = __webpack_public_path__ + "img/logo.46249540.svg";